
import React from 'react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle, CardFooter } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { CheckCircle, User } from 'lucide-react';
import { ProfileUpdateData } from '@/contexts/auth/types';

interface ParticipantProfileFormProps {
  formData: {
    firstName: string;
    lastName: string;
    academicTitle: string;
    formalSalutation: string;
  };
  isLoading: boolean;
  handleInputChange: (e: React.ChangeEvent<HTMLInputElement>) => void;
  handleProfileUpdate: (e: React.FormEvent) => Promise<void>;
}

const ParticipantProfileForm: React.FC<ParticipantProfileFormProps> = ({
  formData,
  isLoading,
  handleInputChange,
  handleProfileUpdate,
}) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <User className="h-5 w-5" />
          Profil adatok
        </CardTitle>
        <CardDescription>
          Az Ön profil adatainak módosítása
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleProfileUpdate} className="space-y-6">
          <div className="grid gap-4 py-4">
            <div className="grid grid-cols-5 gap-4">
              <div className="space-y-2">
                <Label htmlFor="academicTitle">Titulus</Label>
                <Input
                  id="academicTitle"
                  name="academicTitle"
                  placeholder="Dr."
                  value={formData.academicTitle}
                  onChange={handleInputChange}
                />
              </div>
              <div className="space-y-2 col-span-2">
                <Label htmlFor="lastName">Vezetéknév</Label>
                <Input
                  id="lastName"
                  name="lastName"
                  placeholder="Kovács"
                  value={formData.lastName}
                  onChange={handleInputChange}
                  required
                />
              </div>
              <div className="space-y-2 col-span-2">
                <Label htmlFor="firstName">Keresztnév</Label>
                <Input
                  id="firstName"
                  name="firstName"
                  placeholder="János"
                  value={formData.firstName}
                  onChange={handleInputChange}
                  required
                />
              </div>

              <div className="space-y-2 col-span-2">
                <Label htmlFor="formalSalutation">Megszólítás</Label>
                <Input
                  id="formalSalutation"
                  name="formalSalutation"
                  placeholder="Mr."
                  value={formData.formalSalutation}
                  onChange={handleInputChange}
                />
              </div>

            </div>
          </div>


          <div className="flex justify-end">
            <Button
              type="submit"
              disabled={isLoading}
              className="flex items-center gap-2"
            >
              <CheckCircle className="h-4 w-4" />
              Mentés
            </Button>
          </div>
        </form>
      </CardContent>
    </Card>
  );
};

export default ParticipantProfileForm;
